interface Props {
  color?: string;
  className?: string;
}

export default function SystemSvg(props: Props) {
  return (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.00131 4.2583C9.00131 3.28722 9.78852 2.5 10.7596 2.5H13.243C14.2141 2.5 15.0013 3.28722 15.0013 4.25831C15.0013 5.61186 16.4666 6.45781 17.6388 5.78104C18.4798 5.29548 19.5552 5.58362 20.0408 6.42462L21.2824 8.57525C21.768 9.41625 21.4798 10.4916 20.6388 10.9772C19.4666 11.654 19.4666 13.3459 20.6388 14.0227C21.4798 14.5082 21.768 15.5836 21.2824 16.4246L20.0408 18.5752C19.5552 19.4162 18.4798 19.7044 17.6388 19.2188C16.4666 18.5421 15.0013 19.3881 15.0013 20.7416C15.0013 21.7127 14.2141 22.5 13.2429 22.5H10.7597C9.78855 22.5 9.00131 21.7127 9.00131 20.7416C9.00131 19.3881 7.53604 18.5421 6.36382 19.2188C5.52283 19.7044 4.44746 19.4162 3.96191 18.5753L2.72024 16.4246C2.23469 15.5836 2.52284 14.5082 3.36383 14.0227C4.53605 13.3459 4.53606 11.654 3.36383 10.9772C2.52284 10.4916 2.23469 9.41624 2.72024 8.57525L3.96192 6.4246C4.44746 5.58361 5.52284 5.29547 6.36384 5.78102C7.53604 6.45779 9.00131 5.61184 9.00131 4.2583Z'
        stroke='white'
        stroke-width='2'
      />
      <path
        d='M16.0013 12.5C16.0013 14.7091 14.2104 16.5 12.0013 16.5C9.79217 16.5 8.00131 14.7091 8.00131 12.5C8.00131 10.2909 9.79217 8.5 12.0013 8.5C14.2104 8.5 16.0013 10.2909 16.0013 12.5Z'
        stroke='white'
        stroke-width='2'
      />
    </svg>
  );
}
